// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d79306b","541":"ea1e4f55","915":"54e6d06e"}[chunkId] + ".chunk.js";
};